class StickyNavigation {
    constructor() {
        this.currentId = null;
        this.currentTab = null;
        this.tabContainerHeight = 70;
        this.lastScroll = 0;

        this.initIntersectionObserver();

        document.querySelectorAll('.sticky-nav-tab').forEach(tab => {
            tab.addEventListener('click', (event) => this.onTabClick(event, tab));
        });

        window.addEventListener('scroll', () => this.onScroll());
        window.addEventListener('resize', () => this.onResize());
    }

    onTabClick(event, element) {
        event.preventDefault();
        const targetId = element.getAttribute('href');
        const targetEl = document.querySelector(targetId);
        if (targetEl) {
            const extraOffset = 45;
            const scrollTop = targetEl.offsetTop - this.tabContainerHeight - extraOffset;
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }
    }

    onScroll() {
        this.checkHeaderPosition();
        this.lastScroll = window.scrollY;

        // Handle case when scrolled to very top
        if (window.scrollY < 10) {
            const firstTab = document.querySelector('.sticky-nav-tab');
            document.querySelectorAll('.sticky-nav-tab').forEach(tab => tab.classList.remove('nav-active'));
            firstTab?.classList.add('nav-active');
        }
    }

    onResize() {
        if (this.currentId) {
            this.setSliderCss(); // Optional: implement if needed
        }
    }

    checkHeaderPosition() {
        const headerHeight = 75;
        const scrollTop = window.scrollY;

        const spaHeader = document.querySelector('.spa-header');
        const stickyNavTabs = document.querySelector('.sticky-nav-tabs');
        const tabsContainer = document.querySelector('.sticky-nav-tabs-container');

        if (scrollTop > headerHeight) {
            spaHeader?.classList.add('spa-header--scrolled');
        } else {
            spaHeader?.classList.remove('spa-header--scrolled');
        }

        if (!stickyNavTabs) return;

        const offset = (stickyNavTabs.offsetTop + stickyNavTabs.offsetHeight - this.tabContainerHeight) - headerHeight;

        if (scrollTop > this.lastScroll && scrollTop > offset) {
            spaHeader?.classList.add('spa-header--move-up');
            tabsContainer?.classList.remove('sticky-nav-tabs-container--top-first');
            tabsContainer?.classList.add('sticky-nav-tabs-container--top-second');
        } else if (scrollTop < this.lastScroll && scrollTop > offset) {
            spaHeader?.classList.remove('spa-header--move-up');
            tabsContainer?.classList.remove('sticky-nav-tabs-container--top-second');
            tabsContainer?.classList.add('sticky-nav-tabs-container--top-first');
        } else {
            spaHeader?.classList.remove('spa-header--move-up');
            tabsContainer?.classList.remove('sticky-nav-tabs-container--top-first');
            tabsContainer?.classList.remove('sticky-nav-tabs-container--top-second');
        }
    }

    initIntersectionObserver() {
        const options = {
            root: null,
            rootMargin: `-${this.tabContainerHeight + 1}px 0px 0px 0px`,
            threshold: 0.3,
        };

        const sections = [];

        document.querySelectorAll('.sticky-nav-tab').forEach(navElem => {
            const targetId = navElem.getAttribute("href");
            const targetEl = document.querySelector(targetId);
            if (targetEl) {
                sections.push({ id: targetId, el: targetEl, tab: navElem });
            }
        });

        const observer = new IntersectionObserver((entries) => {
            let visibleEntry = null;

            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!visibleEntry || entry.boundingClientRect.top < visibleEntry.boundingClientRect.top) {
                        visibleEntry = entry;
                    }
                }
            });

            if (visibleEntry) {
                const activeId = `#${visibleEntry.target.id}`;
                document.querySelectorAll('.sticky-nav-tab').forEach(tab => {
                    tab.classList.toggle('nav-active', tab.getAttribute('href') === activeId);
                });
            }
        }, options);

        sections.forEach(section => observer.observe(section.el));
    }
    
}
 
new StickyNavigation();
